import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { GridComponent } from '../grid/grid.component';
import {
  ZTreeModel,
  ExternalDataForTree,
  treeToolbarButtonModel,
} from '../models/ITreeModel';
import { NgxLiveViewService } from '../ngx-live-view.service';
import { TreeViewService } from './tree-view.service';

declare var $: any;
declare var fuzzySearch: any;
declare var fuzzySearchParam: any;

@Component({
  selector: 'lib-tree-view',
  templateUrl: './tree-view.component.html',
  styleUrls: ['./tree-view.component.scss'],
})
export class TreeViewComponent implements OnInit, OnChanges {
  nodesToBeInserted: any[] = [];
  isDomCreated: boolean = false;
  search: boolean = false;
  searchText: string = '';
  searchWithParam = 'name';

  currentSelectedNode: any;
  @Input() theme: string = 'dark';
  @Input() treeID = '';
  @Input() toolbarButtons: treeToolbarButtonModel[] = [
    {
      id: 'refresh',
      matIcon: 'autorenew',
      toolTip: 'Refresh',
    },
  ];
  @Output() NodeUnSelected = new EventEmitter();
  @Output() NodeSelected = new EventEmitter();
  @Output() NodeChecked = new EventEmitter();
  @Output() NodeUnChecked = new EventEmitter();
  @Output() NodeSingleClick = new EventEmitter();
  @Output() NodeDoubleClick = new EventEmitter();
  @Output() ContextmenuClicked = new EventEmitter();
  @Output() toolbarButtonClicked = new EventEmitter();
  @Output() EmitEventonNodeExpand = new EventEmitter();
  @ViewChildren(MatMenuTrigger) matMenuTrigger: QueryList<MatMenuTrigger> =
    {} as QueryList<MatMenuTrigger>;

  menuTopLeftPosition = { x: '0', y: '0' };
  constructor(
    private _treeService: TreeViewService,
    private _ngxLiveViewService: NgxLiveViewService
  ) {}

  /* A function that is called before a node is clicked. */
  onBeforeClick = (treeId: any, treeNode: any) => {
    console.log('before click', treeId, treeNode);

    var zTree = $.fn.zTree.getZTreeObj(treeId);
    if (treeNode.isParent) {
      zTree.expandNode(treeNode);
      return true;
    } else {
      return true;
    }
  };

  /**
   * Emits an Event, when a node is selected
   *
   * @param {*} event
   * @param {*} treeID
   * @param {ZTreeModel} targetNode
   * @param {*} moveType
   * @memberof TreeViewComponent
   */
  onNodeSingleClick = (
    event: any,
    treeID: any,
    targetNode: ZTreeModel,
    moveType: any
  ) => {
    console.log('onNodeSingleClick', event, treeID, targetNode, moveType);
    event = event || window.event;
    var key = event.which || event.keyCode; // keyCode detection
    var iscntrlIsPressed = event.ctrlKey ?? (key === 17 ? true : false); // ctrl detection

    let selectedNodes: Array<ZTreeModel> = this.getSelectedNodes();

    if (!iscntrlIsPressed) {
      if (this.currentSelectedNode) {
        if (this.currentSelectedNode.id != targetNode.id) {
          this.NodeUnSelected.emit(this.currentSelectedNode);
          this.currentSelectedNode = targetNode;
          this.NodeSelected.emit(targetNode);
        }
      } else {
        this.currentSelectedNode = targetNode;
        this.NodeSelected.emit(targetNode);
      }
      this.NodeSingleClick.emit(targetNode);
    }
  };

  /**
   * Emits an Event, when a node is double clicked
   *
   * @param {(Event | undefined)} event
   * @param {*} treeId
   * @param {*} treeNode
   * @memberof TreeViewComponent
   */
  onNodeDblClick = (event: Event | undefined, treeId: any, treeNode: any) => {
    console.log('onNodeDblClick', event, treeId, treeNode);
    event = event || window.event;
    this.NodeDoubleClick.emit(treeNode);
  };

  /**
   * It is used to check weather a node is droppable or not
   *
   * @param {*} treeId
   * @param {Array<ZTreeModel>} treeNodes
   * @returns {boolean}
   * @memberof TreeViewComponent
   */
  onNodebeforeDrag = (treeId: any, treeNodes: Array<ZTreeModel>) => {
    console.log('onNodebeforeDrag', treeId, treeNodes);
    if (treeNodes.length == 1) {
      let currentDraggedNode = treeNodes[0];
      if (currentDraggedNode.data.isDroppable) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  /**
   * It is used when a node is dropped, and plays video if it is a video node and dropped on a Grid or do other works
   *
   * @param {{ target: any; originalEvent: { path: any[]; }; }} event
   * @param {*} treeId
   * @param {Array<ZTreeModel>} treeNodes
   * @param {*} targetNode
   * @param {*} moveType
   * @param {*} isCopy
   * @returns {boolean}
   * @memberof TreeViewComponent
   */
  onNodeDrop = (
    event: { target: any; originalEvent: any },
    treeId: any,
    treeNodes: Array<ZTreeModel>,
    targetNode: any,
    moveType: any,
    isCopy: any
  ) => {
    // console.log("onNodeDrop", treeNodes, treeId, event, targetNode, moveType, isCopy);
    // console.log("Parent Node : ", event.target.id == "" ? event.target.parentNode.id : event.target.id)
    let droppableZone: string = '';
    let target = event.target;
    let pathList: any[] = event.originalEvent.composedPath();
    let gridElem = pathList.find(elem => {
      if (elem.classList)
        return elem.classList.value.split(' ').includes('gridDroppableZone');
      else return false;
    });
    if (gridElem) {
      droppableZone = 'grid';
    }

    if (target.className == 'ol-unselectable') {
      droppableZone = 'map';
    }

    let targetId: string = target.id;
    let x = targetId.substring(0, 4);
    if (x == 'Grid') {
      droppableZone = 'grid';
    }
    let node = treeNodes[0];

    if (droppableZone == 'map') {
      //this.commonService.nodeDropOnMapSubject.next({ event, node });
    }

    if (droppableZone == 'grid') {
      // console.log("grid zone drop")
      // console.log(event)
      // console.log(node)
      let parentNode =
        event.target.id == '' ? event.target.parentNode.id : event.target.id;
      this._ngxLiveViewService.playVideo({
        nodeData: treeNodes[0],
        parentNode: parentNode,
      });
      //this._treeService.nodeDropInGridSubject.next({ nodeData: treeNodes[0], parentNode: parentNode });
    }
  };

  /**
   * Emit event on node checked
   *
   * @param {*} treeId
   * @param {*} treeNodes
   * @param {{ checked: any; }} targetNode
   * @param {*} moveType
   * @memberof TreeViewComponent
   */
  onNodeCheck = (
    treeId: any,
    treeNodes: any,
    targetNode: { checked: any },
    moveType: any
  ) => {
    console.log('onNodeCheck', treeId, treeNodes, targetNode, moveType);
    if (targetNode.checked) {
      this.NodeChecked.emit(targetNode);
    } else {
      this.NodeUnChecked.emit(targetNode);
    }
  };

  /**
   * Emit event on node right click on any node
   *
   * @param {*} event
   * @param {*} treeId
   * @param {*} node
   * @memberof TreeViewComponent
   */
  onNodeRightClick = (event: any, treeId: any, node: any) => {
    console.log('onNodeRightClick', event, treeId, node);
    var treeObj = this.getTreeObject();

    treeObj.selectNode(node, false);
    event.preventDefault();

    // we record the mouse position in our object
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';

    // we open the menu
    // we pass to the menu the information about our object
    this.matMenuTrigger.toArray()[0].menuData = { item: node };

    // we open the menu
    this.matMenuTrigger.toArray()[0].openMenu();
    this.ContextmenuClicked.emit({ node, event });
  };

  /**
   * Emit event on node expand
   *
   * @param {*} event
   * @param {*} treeId
   * @param {*} node
   * @memberof TreeViewComponent
   */
  onNodeExpand = (event: any, treeId: any, node: any) => {
    this.currentSelectedNode = node;
    console.log('onNodeExpand', event, treeId, node);
    this.EmitEventonNodeExpand.emit(node);
  };

  /**
   * Expand the nodes
   *
   * @param {*} treeId
   * @param {*} treeNode
   * @memberof TreeViewComponent
   */
  onBeforeExpand = (treeId: any, treeNode: any) => {
    var pNode = this.currentSelectedNode
      ? this.currentSelectedNode.getParentNode()
      : null;
    var treeNodeP = treeNode.parentTId ? treeNode.getParentNode() : null;
    var zTree = $.fn.zTree.getZTreeObj(this.treeID);
    for (
      var i = 0, l = !treeNodeP ? 0 : treeNodeP.children.length;
      i < l;
      i++
    ) {
      if (treeNode !== treeNodeP.children[i]) {
        zTree.expandNode(treeNodeP.children[i], false);
      }
    }
    while (pNode) {
      if (pNode === treeNode) {
        break;
      }
      pNode = pNode.getParentNode();
    }
    if (!pNode) {
      this.singlePath(treeNode);
    }
  };

  setting = {
    view: {
      dblClickExpand: false,
      showLine: false,
      showIcon: true,
      selectedMulti: true,
      addDiyDom: this.addDiyDom,
    },
    edit: {
      drag: {
        prev: false,
        next: false,
        inner: true,
      },
      enable: true,
      showRemoveBtn: false,
      showRenameBtn: false,
    },
    data: {
      key: {
        title: 'title',
      },
      simpleData: {
        enable: true,
        idKey: 'id',
        pIdKey: 'pId',
        rootPId: '',
      },
    },
    check: {
      enable: true,
      chkStyle: 'checkbox',
      chkboxType: { Y: 'ps', N: 'ps' },
    },
    callback: {
      beforeClick: this.onBeforeClick,
      onClick: this.onNodeSingleClick,
      onCheck: this.onNodeCheck,
      onRightClick: this.onNodeRightClick,
      beforeDrag: this.onNodebeforeDrag,
      onDrop: this.onNodeDrop,
      beforeExpand: this.onBeforeExpand,
      onExpand: this.onNodeExpand,
      onDblClick: this.onNodeDblClick,
    },
  };

  ngOnInit(): void {
    console.log(this.treeID);
    // get element by id
    var treeElement = document.getElementById('ztree');
    // change id to treeID
    treeElement!.id = this.treeID;
    var t = $('#' + this.treeID);
    var x = $.fn;
    t = (<any>$).fn.zTree.init(t, this.setting, []);
  }

  ngOnChanges(changes: SimpleChanges): void {
    var s = this.toolbarButtons;
    console.log(this.treeID);
  }

  /**
   * It is used to add styling to the tree node
   *
   * @param {*} treeId
   * @param {{ tId: string; level: number; }} treeNode
   * @memberof TreeViewComponent
   */
  addDiyDom(treeId: any, treeNode: { tId: string; level: number }) {
    var spaceWidth = 5;
    var switchObj = $('#' + treeNode.tId + '_switch'),
      icoObj = $('#' + treeNode.tId + '_ico');
    // add class NodeIcon to icoObj
    icoObj.addClass('NodeIcon');
    switchObj.remove();
    icoObj.before(switchObj);

    if (treeNode.level > 1) {
      var spaceStr =
        "<span style='display: inline-block;width:" +
        spaceWidth * treeNode.level +
        "px'></span>";
      switchObj.before(spaceStr);
    }
  }

  /**
   *It is used to get tree object
   *
   * @return {*}
   * @memberof TreeViewComponent
   */
  getTreeObject() {
    return $.fn.zTree.getZTreeObj(this.treeID);
  }

  /**
   * It is used to insert nodes into tree
   *
   * @param {*} parentNode
   * @param {Array<ZTreeModel>} nodes
   * @memberof TreeViewComponent
   */
  public insertNodes(parentNode: any, nodes: Array<ZTreeModel>) {
    this._treeService.insertNodes(this.treeID, parentNode, nodes);
  }

  /**
   * It emits a event when toolbar button is clicked
   *
   * @param {*} id
   * @memberof TreeViewComponent
   */
  public toolbarButtonClick(id: any) {
    console.log(id);
    this.toolbarButtonClicked.emit(id);
  }

  /**
   * It searches node in tree
   *
   * @memberof TreeViewComponent
   */
  searchNode() {
    this.search = !this.search;
    $(document).ready(() => {
      $('#search').focus();
    });
    if (this.search) {
      setTimeout(() => {
        fuzzySearchParam(
          this.treeID,
          '.CustomsearchNode',
          false,
          true,
          this.searchWithParam
        ); //initialize fuzzysearch function
      }, 1000);
    }
  }

  /**
   * It Clears Search Field
   *
   * @memberof TreeViewComponent
   */
  clearSearchField() {
    this.searchText = '';
    var x = $('.CustomsearchNode')[0];
    x.value = '';
    $('.CustomsearchNode').trigger('propertychange');
  }

  /**
   * It Removes Search Bar
   *
   * @memberof TreeViewComponent
   */
  RemoveSearchBar() {
    //$('.CustomsearchNode').value = '';
    this.searchText = '';
    var x = $('.CustomsearchNode')[0];
    x.value = '';
    $('.CustomsearchNode').trigger('propertychange');
    this.search = false;
  }

  public filterNodes() {}

  /**
   * It is used to get the selected nodes
   *
   * @return {*} Tree Nodes
   * @memberof TreeViewComponent
   */
  public getSelectedNodes() {
    let treeObj = this.getTreeObject();
    if (treeObj) {
      return treeObj.getSelectedNodes();
    }
  }

  /**
   * It is used to collapse any open single path, if any other path is called to open
   *
   * @param {*} newNode
   * @memberof TreeViewComponent
   */
  singlePath(newNode: any) {
    if (newNode === this.currentSelectedNode) return;

    var zTree = $.fn.zTree.getZTreeObj(this.treeID),
      rootNodes,
      tmpRoot,
      tmpTId,
      i,
      j,
      n;

    if (!this.currentSelectedNode) {
      tmpRoot = newNode;
      while (tmpRoot) {
        tmpTId = tmpRoot.tId;
        tmpRoot = tmpRoot.getParentNode();
      }
      rootNodes = zTree.getNodes();
      for (i = 0, j = rootNodes.length; i < j; i++) {
        n = rootNodes[i];
        if (n.tId != tmpTId) {
          zTree.expandNode(n, false);
        }
      }
    } else if (this.currentSelectedNode && this.currentSelectedNode.open) {
      if (newNode.parentTId === this.currentSelectedNode.id) {
        zTree.expandNode(this.currentSelectedNode, false);
      } else {
        var newParents = [];
        while (newNode) {
          newNode = newNode.getParentNode();
          if (newNode === this.currentSelectedNode) {
            newParents = [];
            break;
          } else if (newNode) {
            newParents.push(newNode);
          }
        }
        if (newParents.length > 0) {
          var oldNode = newNode;
          var oldParents = [];
          while (oldNode) {
            oldNode = oldNode.getParentNode();
            if (oldNode) {
              oldParents.push(oldNode);
            }
          }
          if (newParents.length > 0) {
            zTree.expandNode(
              oldParents[Math.abs(oldParents.length - newParents.length) - 1],
              false
            );
          } else {
            zTree.expandNode(oldParents[oldParents.length - 1], false);
          }
        }
      }
    }
    this.currentSelectedNode = newNode;
  }
}
